<template>
    <v-chip-group multiple column class="ma-n4" :key="form.links.length">
        <template v-for="(item, i) in form.links">
            <links-popup v-model="form.links[i]" :key="i" @input="emit">
                <template #activator="{ attrs, on }">
                    <v-chip outlined large label class="ma-4" close v-bind="attrs" v-on="on" @click:close="pull(item)">
                        <span>{{ item.name }}</span>
                    </v-chip>
                </template>
            </links-popup>
        </template>
        <links-popup isCreate @input="push">
            <template #activator="{ attrs, on }">
                <v-btn tag="v-chip" outlined large label width="32" min-width="32" height="32" class="ma-4 pa-0" v-bind="attrs" v-on="on">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
        </links-popup>
    </v-chip-group>
</template>

<script>
import { initLecture } from "@/store/lecture/lecture.inits";

import LinksPopup from "./links/links-popup.vue";

export default {
    components: {
        LinksPopup,
    },
    props: {
        value: { type: Object, default: initLecture },
    },
    data: () => ({
        form: initLecture(),
    }),
    methods: {
        sync() {
            this.form = initLecture(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        pull({ tempId }) {
            let index = this.form.links.findIndex((item) => item.tempId == tempId);
            if (-1 < index) this.form.links.splice(index, 1);
            this.emit();
        },
        push(item) {
            let index = this.form.links.findIndex((__item) => __item.tempId == item.tempId);
            if (-1 < index) this.form.links.splice(index, 1, item);
            else this.form.links.push(item);
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-chip {
        &,
        &::before {
            background: none !important;
        }
    }
}
</style>
